<div class="sitemap-group">
  <div class="sitemap-wrapper">
    <h1>Sitemap</h1>
    <div class="sitemap-outer">
      <ul class="service-list">
        <li>
          <a [routerLink]="['/about-avaana']">About Avaana</a>
        </li>
        <li>
          <a [routerLink]="['/blog']">Avaana Answers</a>
        </li>
        <li>
          <a [routerLink]="['/community-guidelines']">Community Guidelines</a>
        </li>
        <li>
          <a [routerLink]="['/privacy-policy']">Privacy Policy</a>
        </li>
        <li>
          <a [routerLink]="['/booking-terms']">Terms of Service</a>
        </li>
        <li>
          <a href="mailto:hello@avaana.com.au" target="_blank">Contact Us</a>
        </li>
        <li>
          <a href="https://listyourbusiness.avaana.com.au/" target="_blank">List with Us</a>
        </li>
        <li>
          <a [routerLink]="['/disclaimer']">Disclaimer</a>
        </li>
        <li>
          <a [routerLink]="['/collection-statements']">Collection Statements</a>
        </li>
      </ul>
      <div class="location-list">
        <ul class="location-section">
          @for (sitemap of siteMapArray(); track sitemap) { @if (sitemap.name.toLowerCase() !== 'others') {
          <li>
            <a [routerLink]="getRouterUrl(sitemap.name)">{{ sitemap.name }}</a>
          </li>
          @for (subsitemap of sitemap.services; track subsitemap) { @if (!checkSiteMapName(subsitemap.name)) {
          <li>
            <a [routerLink]="getRouterUrl(subsitemap.name, sitemap.name)">{{ subsitemap.name }}</a>
          </li>
          } } } }
        </ul>
      </div>
    </div>
  </div>
</div>
